import { render } from "./ArtistWithNameAndImage.vue?vue&type=template&id=7aabb3eb"
import script from "./ArtistWithNameAndImage.vue?vue&type=script&lang=js"
export * from "./ArtistWithNameAndImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__